var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import { SelectorMultiple } from "@/components/dev/selector/multiple";
import copy from "fast-copy";
import { encodeMultiEnum, unencodeMultiEnum } from "./detail";
import Input from "@mui/joy/Input";
/** <b>Composant en mode consultation/detail d'un champ de type multienum</b>*/
export default function MultiEnumFieldEdit(_a) {
    var _this = this;
    var fieldName = _a.fieldName, record = _a.record, onUpdate = _a.onUpdate, fieldMetadata = _a.fieldMetadata, isOnStudio = _a.isOnStudio, isReport = _a.isReport;
    var t = useTranslation(["common"]).t;
    var defaultValue = useMemo(function () {
        if (!record) {
            return;
        }
        return isReport
            ? record.value
            : record[fieldName || ""] || (fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.default);
    }, [fieldName, record]);
    var _b = useState(), value = _b[0], setValue = _b[1];
    var options = function () {
        var optionsObejct = t("app_lists")[fieldMetadata.options] || {};
        var values = [];
        for (var p in optionsObejct) {
            values.push({ id: p, name: optionsObejct[p] });
        }
        return values;
    };
    useEffect(function () {
        setValue(defaultValue || "");
    }, [defaultValue]);
    var _c = useState(options || []), optionList = _c[0], setoptionList = _c[1];
    var _d = useState([]), selectedFilters = _d[0], setSelectedFilters = _d[1];
    useEffect(function () {
        value && setSelectedFilters(unencodeMultiEnum(value));
    }, [value]);
    var onSelectHandler = function (value) {
        var _a;
        setSelectedFilters(value);
        onUpdate && onUpdate((_a = {}, _a[fieldName] = encodeMultiEnum(value), _a));
    };
    var removeItem = function (id) { return __awaiter(_this, void 0, void 0, function () {
        var copySelectedFilters;
        var _a;
        return __generator(this, function (_b) {
            copySelectedFilters = copy(selectedFilters);
            copySelectedFilters.splice(id, 1);
            setSelectedFilters(copySelectedFilters);
            onUpdate &&
                onUpdate((_a = {}, _a[fieldName] = encodeMultiEnum(copySelectedFilters), _a));
            return [2 /*return*/];
        });
    }); };
    return (_jsx("div", { children: isOnStudio ? (_jsx(Input, { type: "text", className: "w-full" })) : (_jsx(SelectorMultiple, { record: optionList, selectedFilters: selectedFilters, addedValue: "", onSelectChange: function (event, value) {
                event === null || event === void 0 ? void 0 : event.stopPropagation();
                onSelectHandler(value);
            }, onDeleteSelect: function (index) {
                removeItem(index);
            } })) }));
}
